import { Dispatch, SetStateAction, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { LearningFilterTitle } from '../../../../../constants';
import Categories from './Categories';
import UpcomingCourses from './UpcomingCourses';
import FindCourseCard from './findCourseCard';
import { CourseFilterProps, LessonFilterProps } from '../../../../../types/Courses';
import { useTranslation } from 'react-i18next';
export type LearningFilterProps = LessonFilterProps | CourseFilterProps;

const LearningFilter = (props: LearningFilterProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  if ('categoriesFilterSelectors' in props) {
    const lessonProps = props as LessonFilterProps;
    return (
      <Col xl="3" className="xl-40 box-col-12 learning-filter">
        <div className="md-sidebar">
          <Button onClick={() => setOpen(!open)} color="primary" className="md-sidebar-toggle">
            {t('filters.studyFilterTitle')}
          </Button>
          <div className={`md-sidebar-aside job-sidebar ${open ? 'open' : ''}`}>
            <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
              <Row>
                <FindCourseCard
                  filters={lessonProps.filters}
                  setFilters={lessonProps.setFilters}
                  categoriesFilterSelectors={lessonProps.categoriesFilterSelectors}
                  durationFilterSelectors={lessonProps.durationFilterSelectors}
                  status={lessonProps.status}
                  title={t('filters.findLesson')}
                />
              </Row>
            </div>
          </div>
        </div>
      </Col>
    );
  }

  // COURSE MODE
  return (
    <Col xl="3" className="xl-40 box-col-12 learning-filter">
      <div className="md-sidebar">
        <Button onClick={() => setOpen(!open)} color="primary" className="md-sidebar-toggle">
          {t('filters.studyFilterTitle')}
        </Button>
        <div className={`md-sidebar-aside job-sidebar ${open ? 'open' : ''}`}>
          <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <Row>
              <FindCourseCard
                filters={props.filters}
                setFilters={props.setFilters}
                durationFilterSelectors={props.durationFilterSelectors}
                status={props.status}
                title={t('filters.findCourse')}
              />
            </Row>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default LearningFilter;
